import axios from 'axios';

export const queryProjects = async (queryModel, pageSize = 5, currentPage = 1) => axios.post(`/api/projects/query/paged?pageSize=${pageSize}&currentPage=${currentPage}`, queryModel);
export const queryFirstProject = async queryModel => axios.post('/api/projects/query/first', queryModel);
export const createProject = async queryModel => axios.post('/api/projects', queryModel);
export const updateProject = async (projectNumber, queryModel) => axios.patch(`/api/projects/${projectNumber}`, queryModel);

export default {
  queryProjects,
  queryFirstProject,
  createProject,
  updateProject,
};